import { render, staticRenderFns } from "./VxNotFound.vue?vue&type=template&id=875a2f22&"
import script from "./VxNotFound.vue?vue&type=script&lang=js&"
export * from "./VxNotFound.vue?vue&type=script&lang=js&"
import style0 from "./VxNotFound.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports